import StepId from "@/model/progress/StepId";

const providerKey = "synchrony_standard*"

export default {
    providerKey,

    routes: [
        {
            name: "paymentPlanReview",
            path: `/providers/${providerKey}/paymentPlanReview`,
            meta: { step: StepId.PAYMENT_OPTIONS },
            component: () => import("@/views/provider/synchrony/SynchronyPaymentPlanReviewView"),
        },
        {
            name: "creditLimitConfirm",
            path: `/providers/${providerKey}/creditLimitConfirm`,
            meta: { step: StepId.PAYMENT_OPTIONS },
            component: () => import("@/views/provider/synchrony/SynchronyCreditLimitConfirmView")
        },
        {
            name: "creditLimitNoOffer",
            path: `/providers/${providerKey}/creditLimitNoOffer`,
            meta: { step: StepId.PAYMENT_OPTIONS },
            component: () => import("@/views/provider/synchrony/SynchronyCreditLimitCheckNoOfferView")
        },
        {
            name: "terms",
            path: `/providers/${providerKey}/terms`,
            meta: { step: StepId.ACCEPT_OFFER },
            component: () => import("@/views/provider/synchrony/SynchronyTermsView")
        },
    ],
}
